import React, { useState, Suspense, lazy }  from "react"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import PropTypes from "prop-types"
import { connect } from "react-redux"

import store from "./Store"
import Footer from "./ui/layout/Footer"
import Header from "./ui/layout/Header"
import PageLoader from "./ui/components/PageLoader"
import { setHasCreatedDatabase } from "./Store/Actions"
import LoginPage from './ui/pages/LoginPage'
import LoginModal from './ui/layout/Header/LoginModal'
import FourZeroFourPage from './ui/pages/FourZeroFourPage'

const Home = lazy(() => import('./ui/pages/Home'))
const Admin = lazy(() => import('./ui/pages/Admin'))
const RailApps = lazy(() => import('./ui/pages/Admin/RailApps'))
const RailAppEditor = lazy(() => import('./ui/pages/Admin/RailApps/RailAppEditor'))
const Users = lazy(() => import('./ui/pages/Admin/Users'))
const About = lazy(() => import('./ui/pages/About'))
const UserSettingsPage = lazy(() => import('./ui/pages/UserSettingsPage'))

const mapStateToProps = state => {
  return {
    hasDatabase: state.root.hasDatabase,
    pageLoader: state.page.pageLoader,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hasCreatedDatabase: status => dispatch(setHasCreatedDatabase(status)),
  }
}

const App = (props) => {
  const [showModal, setShowModal] = useState(false)
  const [appConfig, setAppConfig] = useState({
    id: "",
    name: "",
    description: "",
    icon: "",
    config: {}
  })

  const routes = store.getState().auth.userIsSet
    ? <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route
            path="*"
            element={<Navigate to="/admin" replace />}
          />
          <Route exact path="home" element={<Home />} />
          <Route exact path="about" element={<About />} />
          <Route exact path="account" element={<UserSettingsPage />} />
          <Route exact path="admin" element={<Admin appConfig={appConfig} setAppConfig={setAppConfig} />}>
            <Route exact path="apps" element={<RailApps {...props} />} />
            <Route exact path="apps/:id" element={<RailAppEditor {...props} />} />
            <Route exact path="users" element={<Users />} />
          </Route>
        </Routes>
      </Suspense>
    : <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route exact path="/" element={<LoginPage showModal={showModal} setShowModal={setShowModal} />} />

          <Route path="*" element={<FourZeroFourPage />} />
        </Routes>

      </Suspense>

  return (
    <div className="core">
      <Router>
        <div className="wrap">
          <Header showModal={showModal} setShowModal={setShowModal} />
          <div className="main--single-full-width">
            {routes}
          </div>
          <Footer />
        </div>
        <PageLoader isActive={props.pageLoader} />
      </Router>
      <LoginModal showModal={showModal} setShowModal={setShowModal} />
    </div>
  )
}

App.propTypes = {
  pageLoader: PropTypes.bool.isRequired,
  hasCreatedDatabase: PropTypes.func.isRequired,
  hasDatabase: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(App)